var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotFoundScreen"},[_c('WText',{style:({ fontSize: '124px', lineHeight: '128px' }),attrs:{"typo":"h1","color":"gray"}},[_vm._v(" 404 ")]),_c('WText',{style:({ fontSize: '60px', lineHeight: '64px' }),attrs:{"typo":"h1"}},[_vm._v(" "+_vm._s(_vm.$t('error.404.title'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }